import { render, staticRenderFns } from "./zlzxAction.vue?vue&type=template&id=4ae97954&scoped=true&"
import script from "./zlzxAction.vue?vue&type=script&lang=js&"
export * from "./zlzxAction.vue?vue&type=script&lang=js&"
import style0 from "./zlzxAction.vue?vue&type=style&index=0&id=4ae97954&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae97954",
  null
  
)

export default component.exports